var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wave",
    style: {
      transform: "rotate(180deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 330",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(62, 163.294, 243, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(11, 73.162, 255, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,165L60,165C120,165,240,165,360,143C480,121,600,77,720,77C840,77,960,121,1080,143C1200,165,1320,165,1440,181.5C1560,198,1680,231,1800,214.5C1920,198,2040,132,2160,110C2280,88,2400,110,2520,132C2640,154,2760,176,2880,181.5C3000,187,3120,176,3240,154C3360,132,3480,99,3600,99C3720,99,3840,132,3960,170.5C4080,209,4200,253,4320,264C4440,275,4560,253,4680,209C4800,165,4920,99,5040,88C5160,77,5280,121,5400,137.5C5520,154,5640,143,5760,126.5C5880,110,6000,88,6120,104.5C6240,121,6360,176,6480,181.5C6600,187,6720,143,6840,115.5C6960,88,7080,77,7200,93.5C7320,110,7440,154,7560,181.5C7680,209,7800,220,7920,214.5C8040,209,8160,187,8280,176C8400,165,8520,165,8580,165L8640,165L8640,330L8580,330C8520,330,8400,330,8280,330C8160,330,8040,330,7920,330C7800,330,7680,330,7560,330C7440,330,7320,330,7200,330C7080,330,6960,330,6840,330C6720,330,6600,330,6480,330C6360,330,6240,330,6120,330C6000,330,5880,330,5760,330C5640,330,5520,330,5400,330C5280,330,5160,330,5040,330C4920,330,4800,330,4680,330C4560,330,4440,330,4320,330C4200,330,4080,330,3960,330C3840,330,3720,330,3600,330C3480,330,3360,330,3240,330C3120,330,3000,330,2880,330C2760,330,2640,330,2520,330C2400,330,2280,330,2160,330C2040,330,1920,330,1800,330C1680,330,1560,330,1440,330C1320,330,1200,330,1080,330C960,330,840,330,720,330C600,330,480,330,360,330C240,330,120,330,60,330L0,330Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.9ab9a1f6bb1ae52cac93073934e3cf22.svg";
export { ForwardRef as ReactComponent };